import React from 'react';
import SampleBannerImg from '../../adminAssets/images/templates/sample_banner.png';

const TemplateLargeBanner = () => {
    return (
        <div className="container" style={{ marginBottom: '48px' }}>
            <img src={SampleBannerImg} alt="Promotional Banner" className="w-100 rounded-16" style={{ objectFit: 'cover' }} />
        </div>
    );
};

export default TemplateLargeBanner;
